import React, { MouseEventHandler } from "react";
import { Button, Modal } from "antd";
import "../../css/jobs.css";

interface ModalChattingSecTypes {
  onCloseModal: MouseEventHandler<HTMLElement>;
  children: JSX.Element;
}

function ModalChattingSec(props: ModalChattingSecTypes) {
  const { onCloseModal } = props;

  return (
    <Modal
      footer={null}
      visible={true}
      className="ant-modal"
      onCancel={(e) => onCloseModal(e)}
    >
      {props.children}
    </Modal>
  );
}
export default ModalChattingSec;
